import { IUserImageAreaModel } from 'src/store/_models/userImageArea';

export function getUserImageAreaTestID(userImageArea: IUserImageAreaModel, placeholderInfo?: string) {
  return placeholderInfo
    ? `user-image.area-${userImageArea.productId}-${userImageArea.id}-${placeholderInfo}`
    : `user-image.area-${userImageArea.productId}-${userImageArea.id}`;
}
